import { Basic } from "../basic.js";
import { deepCompare } from "../../lib/utils.js";
import styles from './window.css'

/**
 * @class MSWindow
 * @extends Basic
 * @classdesc Окно
 */
export class MSWindow extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "template",
            "typeid",
            "position",
            "proportiontype",
            "typed",
            "parameters"
        ]);
    }
    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open" });
        // if (document.body.querySelector('ms-window') == this) {
        //     this.width = window.innerWidth;
        //     this.height = window.innerHeight;
        // }
        this._cacheClass = {};

        shadowRoot.innerHTML = `
            <style>${styles}</style>
            <slot></slot>
        `;

        this.eventListener = this.eventListener.bind(this);
        window.addEventListener("ms_message", this.eventListener);
        this.proportiontype = 4;
        this.contentMaxZIndex = 0;
        //proto basic
        this.backgroundcolor = "rgb(245,240,245)";
        this.style.boxSizing = "border-box";
        this.style.border = "1px solid gray";
        this.mergeParam();
        this.mergeLocationParams();
    }

    eventListener(message) {
        const data = message.data;
        switch (data.event) {
            case "afterswitch":
                this.changeUser();
                break;
        }
    }

    mergeLocationParams() {
        const search = location.search;
        const windowId = search.substring(1, search.indexOf("&"));
        if (this.id !== windowId) {
            return;
        }

        const urlSearchParams = new URLSearchParams(search);
        const locationProps = ["objectid", "outerpath", "taskid"];
        for (const prop of locationProps) {
            const val = urlSearchParams.get(prop);
            val && this.setAttribute(prop, val);
        }
    }

    mergeParam() {
        if ($WinDefs.winDef[this.typeid]) {
            const def = $WinDefs.winDef[this.typeid];
            for (const key in def) {
                if (key == "actionlist") {
                    this.actionlist = JSON.stringify(JSON.parse(def[key]));
                    continue;
                }
                if (typeof def[key] === "object" && def[key] !== null) {
                    this[key] = JSON.parse(JSON.stringify(def[key]));
                } else if (this.getAttribute(key) == null) {
                    this[key] = JSON.parse(JSON.stringify(def[key]));
                }
            }
        }
    }

    changeUser() {
        if (this.isenabled && this._maskElement) {
            this.isenabled = true;
        }
        $pm.controlEnable(this.childNodes);
    }

    get isContainer() {
        return true;
    }

    isPopup() {
        return this.parentNode && this.parentNode.nodeName === "MS-POPUP";
    }

    get template() {
        return this._templateId;
    }
    set template(value) {
        this._templateId = value;
        const template = document.querySelector(`template#${value}`);
        if (template) {
            // parentElement может быть равен null, если элемент склонирован, но не вставлен в DOM,
            // такое может быть в panelstask и для этого случая не нужно проверять isMainWindowCanBeRendered
            if (this.parentElement?.nodeName === "BODY") {
                if (this.isMainWindowCanBeRendered) {
                    this.innerHTML = template.innerHTML;
                }
            } else {
                this.insertTemplateHTML(template.innerHTML);
                this._calcScale();
            }
        } else if ($WinDefs.winDef[this.id]) {
            const win = JSON.parse(JSON.stringify($WinDefs.winDef[this.id]));
            this._isWinDefTemplate = true;
            for (const key in win) {
                if (win.hasOwnProperty(key)) {
                    if (key !== "template") {
                        this[key] = win[key];
                    }
                }
            }
            this._isWinDefTemplate = false;
            this._connectedWindow();
        }
    }

    insertTemplateHTML(templateHTML) {
        if (this.transformationContainerScale) {
            this.transformationContainerScale.innerHTML = templateHTML;
        } else {
            this.innerHTML = templateHTML;
        }
    }

    renderMainWindow() {
        if (this.isMainWindowCanBeRendered) {
            return;
        }
        this.isMainWindowCanBeRendered = true;
        this.template = this.template;
        this.isMainWindowCanBeRendered = false;
    }

    get proportiontype() {
        return this._proportiontype;
    }
    set proportiontype(value) {
        this._proportiontype = Number(value);
        this._calcScale();
    }

    get parameters() {
        return this._parameters;
    }
    set parameters(value) {
        try {
            this._parameters = value
            const params = JSON.parse(value)
            const keys = Object.keys(params)
            for (const key of keys) {
                const data = params[key]
                this.attributeChangedCallback(key, this[key], data)
                this[key] = data
            }
        } catch (e) {
            console.log('ERROR IN PARAMETERS WINDOW ', e)
        }
    }

    get angle() {
        return this._rotate ?? 0;
    }
    set angle(value) {
        this._rotate = +value;
        this._calcScale();
    }

    get scalex() {
        return this._scalex ?? 1;
    }
    set scalex(value) {
        this._scalex = +value;
        this._calcScale();
    }

    get scaley() {
        return this._scaley ?? 1;
    }
    set scaley(value) {
        this._scaley = +value;
        this._calcScale();
    }

    /**
     * Ширина
     * @type {number}
     */
    get width() {
        return this._width;
    }
    set width(value) {
        super.width = value;
        if (this.isPopup()) {
            this.parentNode.onResizeContent();
        }
        this._calcScale();
    }
    /**
     * Высота
     * @type {number}
     */
    get height() {
        return this._height;
    }

    set height(value) {
        super.height = value;
        if (this.isPopup()) {
            this.parentNode.onResizeContent();
        }
        this._calcScale();
    }

    /**
     * Видимость
     * @type {bool}
     */
    get isvisible() {
        return this._showElement;
    }
    set isvisible(value) {
        this._showElement = value;
        const isShow =
            (this.opacity === "" || this._toBool(this.opacity)) &&
            this._toBool(value);
        if (!this._isInited) {
            this.style.visibility = isShow ? "" : "hidden";
        } else {
            if (this.style.visibility === "hidden") this.style.visibility = "";
            this.style.display = isShow ? "flex" : "none";
        }
    }

    _initSkin() {
        this._main = this.shadowRoot.querySelector("svg");
    }

    setSvgParams(svgPath, value) {
        if (this.issvg) {
            let paths = svgPath.split(":");
            if (paths[0] === "svg") paths = paths.splice(1);
            this.svg(paths, value);
        }
    }

    svg(path, value) {
        const items = this._main.querySelectorAll(`[id=${path[0]}]`);
        if (items.length > 0) {
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                switch (path[1]) {
                    case "fill":
                        item.style.fill = value;
                        break;
                    case "Content":
                        item.textContent = value;
                        break;
                    case "class":
                        if (path[2]) {
                            if (this._cacheClass[path[2]]) {
                                item.classList.remove(
                                    this._cacheClass[path[2]]
                                );
                            }
                        } else {
                            while (item.classList.length > 0) {
                                item.classList.remove(item.classList.item(0));
                            }
                        }
                        if (value && value.trim().length > 0)
                            item.classList.add(value);
                        break;
                    default:
                        if (
                            path[0] == "feColorMatrixBodyFilter" ||
                            item.nodeName === "feColorMatrix"
                        ) {
                            const color = this._colorValues(value);
                            if (color) {
                                const r = (color[0] / 255).toFixed(2);
                                const g = (color[1] / 255).toFixed(2);
                                const b = (color[2] / 255).toFixed(2);
                                value = `${r} 0 0 0 0 0 ${g} 0 0 0 0 0 ${b} 0 0 0 0 0 ${color[3]} 0`;
                            }
                            // item.setAttribute(path[1], matrix);
                        }
                        if (item.attributes.getNamedItem(path[1])) {
                            item.setAttribute(path[1], value);
                        } else {
                            for (const key in this._cacheClass) {
                                const el = this._cacheClass[key];
                                if (el) {
                                    const items = this._main.querySelectorAll(
                                        `.${el}`
                                    );
                                    for (
                                        let index = 0;
                                        index < items.length;
                                        index++
                                    ) {
                                        items[index].classList.toggle(el);
                                        requestAnimationFrame(() => {
                                            items[index].classList.toggle(el);
                                        });
                                    }
                                }
                            }
                        }
                }
            }
            if (path[1] === "class" && path[2]) {
                if (value) {
                    this._cacheClass[path[2]] = value;
                }
            }
        } else if (path[0] === "AvaryBorder") {
            const style = document.createElement("style");
            style.type = "text/css";
            style.innerHTML =
                "#AvaryBorder {display:none;} #AvaryBorder.Alarm {display:block; stroke:rgb(255,0,0);} #AvaryBorder.Warning {display:block; stroke:rgb(255,170,0);}";
            this._main.appendChild(style);
            const rect = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "rect"
            );
            rect.setAttribute("id", "AvaryBorder");
            let x, y;
            if (this._main.viewBox) {
                x = this._main.viewBox.baseVal.x;
                y = this._main.viewBox.baseVal.y;
            }
            rect.setAttribute("x", x || 0);
            rect.setAttribute("y", y || 0);
            rect.setAttribute("height", "100%");
            rect.setAttribute("width", "100%");
            rect.style.fill = "rgb(0,0,0)";
            rect.style.strokeWidth = "1";
            rect.style.fillOpacity = "0";
            rect.innerHTML = `<animate xmlns="http://www.w3.org/2000/svg" attributeName="opacity" attributeType="XML" begin="0s; animEnd.end" dur="1s" values="0;1;0" repeatCount="indefinite"/>`;
            this._main.appendChild(rect);
            this.svg(path, value);
        }
    }

    _calcScale() {
        const hasTypeId = this.typeid && this.typeid != this.id;
        if (!hasTypeId || this.hasAttribute("root")) {
            this.scaleDefault();
            return;
        }

        const { width, height } = $WinDefs.winDef[this.typeid];
        const { scaleX, scaleY } = this.calcScaleProportionType(+this.width, +this.height, +width, +height);
        if (scaleX != 1 || scaleY != 1) {
            const hasTransformation = this.scalex !== 1 || this.scaley !== 1 || this.angle !== 0;
            if (hasTransformation) {
                this.scaleDefault();
                this.updateTransformation(scaleX, scaleY);
            } else {
                this.clearInnerTransformation(scaleX, scaleY, width, height);
            }
        } else {
            this.scaleDefault();
        }
    }

    scaleDefault() {
        this.style.transform = `scale(${this.scalex}, ${this.scaley}) rotate(${this.angle}deg)`;
        this.style.transformOrigin = "center";
        this.style.width = this._setValueUnit(this.width);
        this.style.height = this._setValueUnit(this.height);
    }

    calcScaleProportionType(widthContainer, heightContainer, width, height){
        let scaleY, scaleX;
        switch (this.proportiontype) {
            case 0:
                scaleY = heightContainer / height;
                scaleX = widthContainer / width;
                break;
            case 1:
                scaleX = scaleY = widthContainer / width
                break;
            case 2:
                scaleX = scaleY = heightContainer / height
                break;
            case 3: {
                const coefficientWindow = width / height
                const coefficientContainer = widthContainer / heightContainer
                if(coefficientWindow > coefficientContainer){
                    scaleX = scaleY = heightContainer / height;
                } else {
                    scaleX = scaleY = widthContainer / width;
                }
                break;
            }
            case 4: {
                const coefficientWindow = width / height
                const coefficientContainer = widthContainer / heightContainer
                if(coefficientWindow < coefficientContainer){
                    scaleX = scaleY = heightContainer / height;
                } else {
                    scaleX = scaleY = widthContainer / width;
                }
                break;
            }
        }
        return { scaleX, scaleY };
    }

    _calcScaleRoot() {
        const { scaleX, scaleY } = this.calcScaleProportionType(window.innerWidth, window.innerHeight, +this.width, +this.height);
        this.style.transform = `scale(${scaleX}, ${scaleY})`;
        this.style.transformOrigin = "0 0";
    }

    updateTransformation(scaleX, scaleY) {
        if (!this.transformationContainerAngle) {
            this.replaceChildren();
            this.addTransformationAngleContainer();
            this.addTransformationScaleContainer();
            this.template = this._templateId;
            this.style.overflow = "visible"; // при повороте контейнера для трансформации на 90deg, он может обрезаться из-за overflow: hidden родительского window 
        }
        this.style.transform = `scale(${this.scalex}, ${this.scaley})`; // угол обязательно нужно очистить у window
        this.transformationContainerAngle.style.transform = `rotate(${this.angle}deg)`;
        this.transformationContainerScale.style.transform = `scale(${scaleX}, ${scaleY})`;
    }

    addTransformationAngleContainer() {
        this.transformationContainerAngle = document.createElement('div');
        const style = this.transformationContainerAngle.style;
        style.position = "absolute";
        style.width = "100%";
        style.height = "100%";
        style.transformOrigin = "center";
        style.overflow = "hidden";
        this.backgroundcolor = this.backgroundcolor;
        this.bordercolor = this.bordercolor;
        this.borderthickness = this.borderthickness;
        this.borderstyle = this.borderstyle;
        this.shadowsize = this.shadowsize;
        this.shadowcolor = this.shadowcolor;
        this.isenabled = this.isenabled;
        this.resource = this.resource;
        this.appendChild(this.transformationContainerAngle);
    }

    addTransformationScaleContainer() {
        this.transformationContainerScale = document.createElement('div');
        const style = this.transformationContainerScale.style;
        style.position = "absolute";
        style.width = "100%";
        style.height = "100%";
        style.transformOrigin = "0 0";
        this.transformationContainerAngle.appendChild(this.transformationContainerScale);
    }

    clearInnerTransformation(scaleX, scaleY, width, height) {
        this.style.transform = `scale(${scaleX}, ${scaleY})`;
        this.style.transformOrigin = "0 0";
        this.style.width = this._setValueUnit(width);
        this.style.height = this._setValueUnit(height);

        if (this.transformationContainerAngle) {
            this.transformationContainerAngle.style.transform = "none";
            this.transformationContainerScale.style.transform = "none";
        }
    }

    scaleRootWindow() {
        let scale, scaleH, scaleW;
        const sh = Number(this.height);
        const sw = Number(this.width);
        scaleH = window.innerHeight / sh;
        scaleW = window.innerWidth / sw;

        scale = scaleH < scaleW ? scaleH : scaleW;

        window.__scale = {
            x: scale,
            y: scale,
        };

        const { heighttype, widthtype } = $WinDefs.winDef[this.id] || {};
        const winStyle = this.style;

        switch (true) {
            case heighttype === "0" && widthtype === "0": {
                winStyle.transform = "";
                winStyle.transformOrigin = "";
                winStyle.overflow = "auto";
                winStyle.width = "100%";
                winStyle.height = "100%";
                break;
            }
            case widthtype === "0": {
                winStyle.transform = `scaleY(${scaleH})`;
                winStyle.transformOrigin = "center 0";
                winStyle.overflowX = "overlay"; // deprecated, но работает, как надо
                winStyle.width = "100%";
                break;
            }
            case heighttype === "0": {
                winStyle.transform = `scaleX(${scaleW})`;
                winStyle.transformOrigin = "0 center";
                winStyle.overflowY = "overlay"; // deprecated, но работает, как надо
                winStyle.height = "100%";
                break;
            }
            default: {
                this._calcScaleRoot();
            }
        }
    }

    get typeid() {
        return this.getAttribute("typeid");
    }
    set typeid(value) {
        this.setAttribute("typeid", value);
    }

    get typed() {
        return this._typed;
    }
    set typed(value) {
        this._typed = value;
    }

    get position() {
        return this._position;
    }
    set position(value) {
        this._position = value;
        this.style.position = value;
    }

    get borderthickness() {
        return this._borderthickness;
    }

    set borderthickness(value) {
        value = parseInt(value, 10);
        if (isNaN(value) || value < 0) {
            return;
        }
        this._borderthickness = value;

        if (this.transformationContainerAngle) {
            this.transformationContainerAngle.style.borderWidth = this._setValueUnit(value);
            this.style.borderWidth = "0px";
            return;
        }

        this.style.borderWidth = this._setValueUnit(value);
    }

    get bordercolor() {
        return this.style.borderColor;
    }

    set bordercolor(value) {
        value = this.tryToGetUserColor(value);
        this.style.setProperty("--borderColor", value);

        if (this.transformationContainerAngle) {
            this.transformationContainerAngle.style.borderColor = value;
            this.style.borderColor = "transparent";
            return;
        }

        this.style.borderColor = value;
    }

    get backgroundcolor() {
        return this._backgroundcolor;
    }

    set backgroundcolor(value) {
        super.backgroundcolor = value;

        if (this.transformationContainerAngle) {
            this.transformationContainerAngle.style.background = this.style.background;
            this.style.background = "transparent";
        }
    }1

    set borderstyle(value) {
        this._borderstyle = value;

        if (this.transformationContainerAngle) {
            this.transformationContainerAngle.style.borderStyle = this.getBorderStyle(window._enums.BorderStyleType[value]);
            this.style.borderStyle = "solid";
            return;
        }

        this.style.borderStyle = this.getBorderStyle(window._enums.BorderStyleType[value]);
    }

    get shadowsize() {
        return this._shadowsize;
    }

    set shadowsize(value) {
        value = parseInt(value, 10);
        if (value >= 0) {
            this._shadowsize = value;

            if (this.transformationContainerAngle) {
                this.style.boxShadow = "none";
            }

            this._calcBlockShadow(this.transformationContainerAngle || this);
        }
    }

    get shadowcolor() {
        return this._shadowcolor;
    }

    set shadowcolor(value) {
        value = this.tryToGetUserColor(value);
        this._shadowcolor = value ? this._transformHexColor(value) : "";

        if (this.transformationContainerAngle) {
            this.style.boxShadow = "none";
        }

        this._calcBlockShadow(this.transformationContainerAngle || this);
    }

    get resource() {
        return this._resource;
    }
    set resource(value) {
        if (this.transformationContainerAngle) {
            this.updateResource(value, this.transformationContainerAngle);
            this.style.backgroundPosition = "0 0";
            this.style.backgroundRepeat = "repeat";
            this.style.backgroundSize = "auto";
            this.style.backgroundImage = "none";
            return;
        }

        this.updateResource(value);
    }

    updateZIndex(value /*:Number*/) {
        if (value > this.contentMaxZIndex) this.contentMaxZIndex = value;
        if (this._maskElement) {
            this._maskElement.style.zIndex = this.contentMaxZIndex + 1;
        }
        this.style.setProperty("--zIndex", this.contentMaxZIndex);
    }

    disableElement() {
        if (this._maskElement || !this._isInited) return;
        const base = this.transformationContainerAngle || this.shRoot || this.shadowRoot;
        this._pointerEvents = this.style.pointerEvents;

        let zIndex = 0;
        this.childNodes.forEach(el => {
            if (Number(el.z) && zIndex < el.z) zIndex = Number(el.z);
        });
        const maskElement = this.createMaskElement(zIndex);

        base.append(maskElement);
        this._maskElement = maskElement;
    }

    connectedCallback() {
        this._openedEventCalled = false;
        if (!this._isWinDefTemplate) {
            this._connectedWindow();
            // super.connectedCallback();
            // const event = new CustomEvent('ms_message');
            // event.data = { event: 'windowStart', window: this };
            // window.dispatchEvent(event);
        }
        this._isInited = true;
        this.isvisible = this.isvisible;
        if (!this.isenabled) {
            this.disableElement();
        }
    }
    afterInitialize() {
        for (let i = 0; i < this.children.length; i++) {
            if (this.children[i].afterInitialize)
                this.children[i].afterInitialize();
        }
        if (!this._openedEventCalled) {
            this._openedEventCalled = true;
            let event = new CustomEvent("windowopened", {
                detail: {},
            });
            this.dispatchEvent(event);
        }
    }

    _connectedWindow() {
        if (!this._winStart) {
            this._winStart = true;
            const event = new CustomEvent("ms_message");
            event.data = { event: "windowStart", window: this };
            window.dispatchEvent(event);
        }
    }

    disconnectedCallback() {
        const event = new CustomEvent("windowclosing", {
            detail: {
                onCompleteCallback: () => {
                    // Навешанных на закрытие окна событий может быть несколько и нужно дождаться их выполнения,
                    // прежде, чем очищать объекты
                    this.innerHTML = "";
                    this.shadowRoot.innerHTML = "";
                    window.removeEventListener("ms_message", this.eventListener);
                    this.eventListener = null;

                    const event = new CustomEvent("ms_message");
                    event.data = { event: "windowRemove", window: this };
                    window.dispatchEvent(event);
                    event.data.window = null;

                    this.windowTriggers = null;
                    this.isdisconnected = true;

                    super.disconnectedCallback();
                },
            },
        });
        this.dispatchEvent(event);
    }

    /**
     * Коллбек по изменению атрибутов элемента
     * @see https://w3c.github.io/webcomponents/spec/custom/
     * @param {string} attrName название атрибута
     * @param {*} oldVal старое значение атрибута
     * @param {*} newVal новое значение атрибута
     * @param {boolean/string} [forced] изменять параметр принудительно (даже если новое значение не отличается от старого).
     * При передаче строки в нее дописывается список Id окон, через параметры которых прошло значение (для избежания зацикливания)
     */
    attributeChangedCallback(attrName, oldVal, newVal, itemIndex, forced) {
        const equalsValue = deepCompare(oldVal, newVal);
        if (forced || !equalsValue) {
            const struct = attrName.split(".");
            if (struct.length > 1) {
                const val =
                    newVal.dataType && newVal.value ? newVal.value : newVal;
                // this[attrName] = val;
                let value = this;
                for (let i = 0; i < struct.length - 1; i++) {
                    value = value?.[struct[i]];
                }
                const keys = Object.keys(value || {});
                const i = keys.findIndex(
                    el => el === struct[struct.length - 1] || el.toLowerCase() === struct[struct.length - 1]  //TODO Проверку toLowerCase убрать потом
                );

                if (value && value[keys[i]] != val) {
                    value[keys[i]] = val;
                    if (this.prop_link[struct[0]]) {
                        this.prop_link[struct[0]](
                            this.pId ? this.pId + "/" + this.id : this.id,
                            this.Links[struct[0]],
                            this[struct[0]],
                            struct[0],
                            this.ItemIndex
                        );
                    }
                }
            } else {
                const val =
                    newVal && newVal.dataType && newVal.value
                        ? newVal.value
                        : newVal;

                if (!equalsValue) {
                    this[attrName] = val;
                    if (this.prop_link[attrName]) {
                        this.prop_link[attrName](
                            this.pId ? this.pId + "/" + this.id : this.id,
                            this.Links[attrName],
                            val,
                            attrName,
                            this.ItemIndex,
                            null,
                            forced
                        );
                    }
                } else if (forced && this.prop_link[attrName]) {
                    let newForced;
                    //Передаем неизменное значение, но с контролем циклов
                    if (typeof forced === "string" && forced.indexOf(this.id + ',') >= 0)
                        return;
                    if (typeof forced === "string")
                        newForced = forced + this.id + ',';
                    else
                        newForced = this.id + ',';
                    this.prop_link[attrName](
                        this.pId ? this.pId + "/" + this.id : this.id,
                        this.Links[attrName],
                        val,
                        attrName,
                        this.ItemIndex,
                        null,
                        newForced
                    );
                }

            }
        }
    }
}